import { jsx, jsxs } from "react/jsx-runtime";
import { AnimatePresence } from "@tamagui/animate-presence";
import { ArrowLeft, ArrowRight } from "@tamagui/lucide-icons";
import { useState } from "react";
import { Button, Image, XStack, YStack, styled } from "tamagui";
import photo1 from "../../public/photo1.jpg";
import photo2 from "../../public/photo2.jpg";
import photo3 from "../../public/photo3.jpg";
const images = [photo1, photo2, photo3].map((x) => x.src || x);
const YStackEnterable = styled(YStack, {
  variants: {
    isLeft: { true: { x: -300, opacity: 0 } },
    isRight: { true: { x: 300, opacity: 0 } }
  }
});
function AnimationsPresenceDemo() {
  const [[page, direction], setPage] = useState([0, 0]);
  const imageIndex = wrap(0, images.length, page);
  const paginate = (newDirection) => {
    setPage([page + newDirection, newDirection]);
  };
  const enterVariant = direction === 1 || direction === 0 ? "isRight" : "isLeft";
  const exitVariant = direction === 1 ? "isLeft" : "isRight";
  return /* @__PURE__ */ jsxs(
    XStack,
    {
      overflow: "hidden",
      backgroundColor: "#000",
      position: "relative",
      height: 300,
      width: "100%",
      alignItems: "center",
      children: [
        /* @__PURE__ */ jsx(AnimatePresence, { enterVariant, exitVariant, children: /* @__PURE__ */ jsx(YStackEnterable, { animation: "bouncy", fullscreen: true, x: 0, opacity: 1, children: /* @__PURE__ */ jsx(Image, { source: { uri: images[imageIndex], width: 780, height: 300 } }) }, page) }),
        /* @__PURE__ */ jsx(
          Button,
          {
            accessibilityLabel: "Carousel left",
            icon: ArrowLeft,
            size: "$5",
            position: "absolute",
            left: "$4",
            circular: true,
            elevate: true,
            onPress: () => paginate(-1)
          }
        ),
        /* @__PURE__ */ jsx(
          Button,
          {
            accessibilityLabel: "Carousel right",
            icon: ArrowRight,
            size: "$5",
            position: "absolute",
            right: "$4",
            circular: true,
            elevate: true,
            onPress: () => paginate(1)
          }
        )
      ]
    }
  );
}
const wrap = (min, max, v) => {
  const rangeSize = max - min;
  return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};
export {
  AnimationsPresenceDemo,
  images
};
//# sourceMappingURL=AnimationsPresenceDemo.js.map
